import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { News } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${News.Pages.NEWS}`,
    name: News.Pages.NEWS,
    component: () => import(/* webpackChunkName: "marketing-fund" */ './views/News.vue'),
    meta: {
      access_roles: RouteRoles[News.Pages.NEWS],
    },
  },
  {
    path: `/${News.Pages.NEWS_DETAIL}`,
    name: News.Pages.NEWS_DETAIL,
    component: () => import(/* webpackChunkName: "marketing-fund" */ './views/NewsDetail.vue'),
    meta: {
      access_roles: RouteRoles[News.Pages.NEWS_DETAIL],
    },
  },
];

export default routes;
